"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriceDiscountTag = void 0;
const common_components_1 = require("@as-react/common-components");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../constants/i18nConstants");
const ProductUtil_1 = require("../util/ProductUtil");
const common_utils_1 = require("@as-react/common-utils");
const usePriceDiscountTag = (priceInformation, dynamicSavingsInformation, enablePriceReference) => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const { currency } = (0, common_components_1.useAemConfig)();
    const productDiscount = (0, ProductUtil_1.getProductDiscount)(dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountAmount, dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountPercentage, currency);
    if (!(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount) || !productDiscount) {
        return undefined;
    }
    return (0, common_utils_1.showPriceDiscount)(priceInformation.prices, Boolean(enablePriceReference))
        ? {
            text: `${t(`${i18nConstants_1.I18N_NAMESPACES.product}:pdp.dynamic.savings`)} ${productDiscount}`,
        }
        : undefined;
};
exports.usePriceDiscountTag = usePriceDiscountTag;
